export var MIN_IMAGE_WIDTH = 1;
export var MAX_IMAGE_WIDTH = 99999;
export var MIN_IMAGE_HEIGHT = 1;
export var MAX_IMAGE_HEIGHT = 99999;
export var API_TIME_OUT = 8 * 1000;
export var SERVER_ERROR_MSG = '服务异常，请稍后重试';
export var SERVER_AUTH_ERROR_MSG = '当前用户无权限，请登录后重试';
export var API_TIMEOUT_ERROR_MSG = '服务超时，请稍后重试';
export var TRANSCODE_ERROR_MSG = '转码失败，请稍后重试';
export var TRANSCODE_TIME_OUT = 60 * 1000;
export var COMPRESSED_IMAGE_SIZE_EXCEED = '图片压缩后超出300KB限制，请调整后重新上传';
export var IMAGE_ACCEPT_TYPES = '.jpg, .jpeg, .png, .webp, .flif, .cr2, .tif, .bmp, .ico';
export var IMAGE_MAX_SIZE_LIMIT = 5 * 1024 * 1024;
export var VIDEO_ACCEPT_TYPES = '.mp4';
export var VIDEO_MAX_SIZE_LIMIT = 100 * 1024 * 1024;
export var CREATIVE_MATERIAL_LIBRARY = 'https://chuangyi.qq.com/material';